import { fromJS, List, Map, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput, ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { Link } from '#utils/linkUtils';

// type DependentFlag struct {
// 	Name  string               `json:"name"`
// 	Key   string               `json:"key"`
// 	Links map[string]core.Link `json:"_links"`
// 	Site  core.Link            `json:"_site"`
// }
export type DependentFlagByEnvProps = {
  key: string;
  name: string;
  archived?: boolean;
  archivedDate?: number;
  _links: ImmutableMap<{
    self: Link;
    flag: Link;
  }>;
  _site: Link;
};
export class DependentFlagByEnv extends Record<DependentFlagByEnvProps>({
  key: '',
  name: '',
  _links: Map(),
  _site: Map(),
}) {}

// type DependentFlagsCollectionRep struct {
// 	Items []DependentFlag      `json:"items"`
// 	Links map[string]core.Link `json:"_links"`
// 	Site  core.Link            `json:"_site"`
// }
export type DependentFlagByEnvCollectionProps = {
  _links: ImmutableMap<{
    self: Link;
    parent: Link;
  }>;
  items: List<DependentFlagByEnv>;
};
export class DependentFlagByEnvCollection extends Record<DependentFlagByEnvCollectionProps>({
  items: List(),
  _links: Map(),
}) {}

// type DependentFlagWithEnvs struct {
// 	Name         string                     `json:"name"`
// 	Key          string                     `json:"key"`
// 	Environments []DependentFlagEnvironment `json:"environments"`
// }
export type DependentFlagProps = {
  key: string;
  name: string;
  archived?: boolean;
  archivedDate?: number;
  environments: List<DependentFlagByEnv>;
};
export class DependentFlag extends Record<DependentFlagProps>({
  key: '',
  name: '',
  environments: List(),
}) {}

// type MultiEnvDependentFlagsCollectionRep struct {
// 	Items []DependentFlagWithEnvs `json:"items"`
// 	Links map[string]core.Link    `json:"_links"`
// 	Site  core.Link               `json:"_site"`
// }
export type DependentFlagCollectionProps = {
  _links: ImmutableMap<{
    self: Link;
    parent: Link;
  }>;
  _site: Link;
  items: List<DependentFlag>;
};
export class DependentFlagCollection extends Record<DependentFlagCollectionProps>({
  items: List(),
  _links: Map(),
  _site: Map(),
}) {}

export function createDependentFlagByEnv(props: CreateFunctionInput<DependentFlagByEnvCollection> = {}) {
  return props instanceof DependentFlagByEnvCollection ? props : new DependentFlagByEnvCollection(fromJS(props));
}

export function createDependentFlag(props: CreateFunctionInput<DependentFlagCollection> = {}) {
  return props instanceof DependentFlagCollection ? props : new DependentFlagCollection(fromJS(props));
}
